import { render, staticRenderFns } from "./channelListAction.vue?vue&type=template&id=55038ff4&scoped=true"
import script from "./channelListAction.vue?vue&type=script&lang=js"
export * from "./channelListAction.vue?vue&type=script&lang=js"
import style0 from "./channelListAction.vue?vue&type=style&index=0&id=55038ff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55038ff4",
  null
  
)

export default component.exports